import { Helmet } from 'react-helmet-async';
import RequestDetails from '../../../components/dashboard/transports/SaveRequest/requestDetails/RequestDetails';

export default function TransportsRequestDetails() {
  return (
    <>
      <Helmet>
        <title>Transports Request Details | Platform Solutions</title>
      </Helmet>
      <RequestDetails />
    </>
  );
}
